import { Box } from '@mui/material';
import Header from 'components/organisms/Header/HomeHeader';
import * as React from 'react';
import Media from 'react-media';
import MobileExplorePage from 'views/MobileViews/MobileExplorePage';
import Explore2 from './Explore2';

const ExplorePage = () => {
  const rootElement = React.useRef<HTMLDivElement>(null);

  return (
    <>
      <Box ref={rootElement}>
        <Media query="(max-width: 599px)">
          {matches => (matches ? <></> : <Header />)}
        </Media>

        <Media query="(max-width: 599px)">
          {matches =>
            matches ? (
              <MobileExplorePage />
            ) : (
              // <Route path="/" element={<MobileExplorePage />} />
              // <DesktopExplorePage />
              <Explore2 />
            )
          }
        </Media>
      </Box>
    </>
  );
};

export default ExplorePage;
